import type { FormDefinition } from '@/core/templates/types'
import { massnahmeDetailsForm } from './templates'
import type { MassnahmeAzavWrite } from './api/resources'

export const ORG_SETTINGS_TABS: readonly string[] = ['organisation', 'coaches', 'massnahmen', 'module']

export const MASSNAHME_FORM: FormDefinition = massnahmeDetailsForm

export const MASSNAHME_DEFAULTS = {
  ansprechpartner: '',
  bezeichnung: '',
  durchf_form: '',
  durchf_ort: '',
  ende_zulassung: '',
  inhalt: '',
  kosten: '',
  nummer: '',
  start_zulassung: '',
  ue_anzahl: 0,
  zeitl_umfang_woche: '',
} satisfies Omit<MassnahmeAzavWrite, 'organisation_id'>

export const HAS_MODULES = true as const

export const HAS_ECN_SETTINGS = true
